export default {
    'diagram1-5c': {
      'title': `Please fill in the rest of the problem definition on the form that follows. I have supplied the Disturbing Event to get you going`,
      'exercise-title': 'LOCATION BASED LEARNING STRATEGY',
      'structure-answers-title': `Elements of the problem definition`,
      'situation-title': 'situation',
      'diagram-header': 'LEARNING CENTERS',
      'left-box': 'REMEDIATION',
      'middle-box': 'TUTORING',
      'right-box': 'TUTORING<br/>(virtual or in person)',
      'bottom-box-points': `
      <ul>
        <li>5-3 years, grades K-8</li>
        <li>Hourly fee + long-term programs</li>
        <li>4-5 national brands dominate</li>
        <li>$2b market</li>
      </ul>
      <ul>
        <li>5-7 years, grades K-12</li>
        <li>Hourly or monthly for unlimited tutoring</li>
        <li>90% fragmented</li>
      </ul>
      <ul>
        <li>5-7 years, grades K12</li>
        <li>Hourly or monthly for unlimited tutoring</li>
        <li>80% fragmented</li>
      </ul>
      `,
      'bottom-box-points-summarize': '$10b addressable market',
      'situation-desc': 'DISTURBING EVENT',
      'situation-desc-points': `
        <ul style="max-width: max-content">
            <li>Growing trend for parents to seek private-pay education to help children compete</li>
            <li>4-5 national brands dominate Remediation Learnng Center market</li>
            <li>Tutoring Center market 90% fragmented, no dominant player</li>
            <li>Address same ages as Turner:  5-17 years old, grades K-12</li>
        </ul>`,
      'structure-box': `
        <p>See offering gaps in</p>
        <ul>
            <li>Enrichment segment of K-5 space (ages 5-10)</li>
            <li>Programs focusing on Arts & Sciences</li>
        </ul>`
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/5/5c/diagram1/i18n/en.js